









import { Component, Vue } from 'vue-property-decorator';
import Headline from '@/components/price/sections/Headline.vue';
import Headline2 from '@/components/price/sections/Headline2.vue';
import Prices from '@/components/price/sections/Prices.vue';
import Contact from '@/components/price/sections/Contact.vue';

@Component({
  components: {
    Headline,
    Headline2,
    Prices,
    Contact
  }
})
export default class Price extends Vue {
}
